
import { Vue, Component } from 'vue-property-decorator';
import Prism from 'prismjs';

@Component
export default class PageCache extends Vue {
  newslist: any[] = [];
  coupleVal = '';
  mounted() {
    Prism.highlightAll();
    const mockArr = [];
    for (let i = 0; i < 10; i++) {
      mockArr.push(i);
    }
    this.newslist = mockArr.map((item: any, index: number) => ({
      rank: index + 1,
      like: Math.round(Math.random() * 100),
    }));
  }
  onNavTo(index: number) {
    this.$routerThen
      .push({
        url: '/demo/detail',
      })
      .then((vm) => {
        vm.$on('like', (val: any) => {
          console.log('%c已点赞, 回传值为: ', 'color: coral', val);
          this.newslist[index].like++;
        });
      });
  }
}
